<template>
  <div>
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="$refs.table.getDataList()"
    >
      <el-form-item label="合同编号：">
        <OrderDrop v-model="dataForm.agreementCode" size="mini"
                   placeholder="请输入订单编号"></OrderDrop>
      </el-form-item>
      <el-form-item label="原料/辅料/成品：">
        <el-input
            v-model="dataForm.productName"
            placeholder="品番号/品名/颜色/尺寸/幅宽/克重"
            clearable
            size="mini"
            style="width:260px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="仓库：" v-if="$hasPermission('store:query:storages')">
        <storages v-model="dataForm.storageId" size="mini"></storages>
      </el-form-item>
      <el-form-item>
        <el-button @click="$refs.table.reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom:20px;">
      <slot name="btns"></slot>
      <el-button type="warning" size="mini" @click="showTransferDialog()"
      >库存调配
      </el-button
      >
    </div>
    <store-table :productType="productType" :queryForm="dataForm" ref="table">
    </store-table>
    <DetailDialog ref="detailDialog" @close="$refs.table.getDataList()"></DetailDialog>
    <TransferDialog ref="transferDialog" @change="$refs.table.reload()"></TransferDialog>
  </div>
</template>

<script>
import DetailDialog from './detail-dialog.vue'
import TransferDialog from './transfer-dialog.vue'
import OrderDrop from '@/components/order-drop'
import StoreTable from '@/views/modules/store/components/store-table'

export default {
  components: {
    OrderDrop,
    DetailDialog,
    TransferDialog, StoreTable
  },
  props: {
    productType: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      dataForm: {
        agreementCode: '',
        productType: '',
        storageId: '',
        productName: '',
      },
    }
  },
  watch:{
    productType:{
      handler:function(newVal){
        this.dataForm.productType=newVal
      },
      immediate:true
    }
  },
  methods: {
    reload(){
      this.$refs.table.reload()
    },
    getDataList(){
      this.$refs.table.getDataList()
    },
    showTransferDialog () {
      if (this.dataListSelections.length === 0) {
        return this.$message.error('请选择要调仓的成品或原辅料')
      }
      const data = this.$clone(this.dataListSelections)
      let outStorageId = ''
      let validRes = true
      data.forEach((item) => {
        item.count = 0
        if (outStorageId == '') {
          outStorageId = item.storageId
        }
        if (outStorageId !== item.storageId) {
          validRes = false
        }
      })
      if (!validRes) {
        return this.$message.error('调出仓库不一致,请重新选择')
      }
      this.$refs.transferDialog.dataForm.checkOutStorageId = outStorageId
      this.$refs.transferDialog.dataForm.detailList = data
      this.$refs.transferDialog.init()
    },
    showDetailDialog (row) {
      this.$refs.detailDialog.dataForm.storageId = row.storageId
      this.$refs.detailDialog.dataForm.agreementId = row.agreementId
      this.$refs.detailDialog.dataForm.agreementCode = row.agreementCode
      this.$refs.detailDialog.dataForm.productId = row.productId
      this.$refs.detailDialog.init()
    },
  },
}
</script>
